import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import LockOutlined from "@material-ui/icons/LockOutlined";
import Email from "@material-ui/icons/Email";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import CalendarTodayOutlined from "@material-ui/icons/CalendarTodayOutlined";
import MobileStepper from "@material-ui/core/MobileStepper";
import grey from "@material-ui/core/colors/grey";
import { reduxForm, Field, submit } from "redux-form";
import {
  geo_fetchRegions,
  geo_fetchCities
} from "../../../redux/actions/geoActions";
import { common_alertOpen } from "../../../redux/actions/commonActions";
import fototipo from "../../../img/other/fototipo_img.png";
import "react-datepicker/dist/react-datepicker.css";
import {
  renderEmailField,
  renderPasswordField,
  renderLastNameField,
  renderFirstNameField,
  renderSecondLastNameField,
  renderDateOfBirthField,
  renderAddressField,
  renderCityField,
  renderPostalCodeField,
  renderMobilePhoneField,
  renderAlternativePhoneNumberField,
  renderGenderField,
  renderHeightField,
  renderWeightField,
  renderOptionsField,
  renderGenericTextField,
  renderGenericCheckboxGroup
} from "../../../helpers/form/fields";
import { renderTextField } from "../../../helpers/form/renders";
import GridField from "../../shared/components/GridField";

import {
  v_required,
  v_email,
  v_arrayMinLength,
  v_number,
  v_height,
  v_policy,
  v_nifNie
} from "../../../helpers/form/validators";
import * as API from "../../../api";

const primaryGrey = grey[600]; // #F44336

const validate = values => {
  const errors = {
    profile: {}
  };

  // Step 0
  errors.email = v_email(values.email);
  errors.password = v_required(values.password);
  errors.first_name = v_required(values.first_name);
  errors.last_name = v_required(values.last_name);

  // if (typeof values !== 'undefined') {
  // Step 1
  errors.dni = v_nifNie(values.dni);
  errors.birthday = v_required(values.birthday);
  errors.address = v_required(values.address);
  errors.city = v_required(values.city);
  errors.postal_code = v_required(values.postal_code);
  errors.mobile_phone_number = v_number(values.mobile_phone_number);
  errors.gender = v_required(values.gender);
  errors.weight = v_number(values.weight);
  errors.height = v_height(values.height);
  errors.has_different_delivery_address = v_required(
    values.has_different_delivery_address
  );
  errors.preferred_delivery_time = v_required(values.preferred_delivery_time);
  if (!values.preferred_delivery_time || Array.isArray(values.preferred_delivery_time) && values.preferred_delivery_time.length < 1) {
    errors.preferred_delivery_time = "Campo obligatorio";
  }
  errors.address_has_doorkeeper = v_required(values.address_has_doorkeeper);

  if (values.has_different_delivery_address === "2") {
    errors.delivery_address = v_required(values.delivery_address);
  }

  // Step 2
  errors.work_status = v_required(values.work_status);
  if (values.work_status === "Otros") {
    errors.work_status_other = v_required(values.work_status_other);
  }
  errors.how_you_know_about_cosmocare = v_required(
    values.how_you_know_about_cosmocare
  );
  // if(values.how_you_know_about_cosmocare === 'Otro') {
  //   errors.how_you_know_about_cosmocare_other = v_required(values.how_you_know_about_cosmocare_other);
  // }
  if (
    values.how_you_know_about_cosmocare &&
    values.how_you_know_about_cosmocare.length < 1
  ) {
    errors.how_you_know_about_cosmocare = "Campo obligatorio";
  }
  errors.using_social_networks = v_required(values.using_social_networks);
  if (values.using_social_networks === "1") {
    errors.social_networks = v_arrayMinLength(1, values.social_networks);
  }
  if (!values.social_networks || values.social_networks.length < 1) {
    errors.social_networks = "Campo obligatorio";
  }
  if (
    values.health_problems &&
    values.health_problems.findIndex(p => p === 9) > -1 &&
    (!values.disease_type_other || values.disease_type_other.length < 1)
  ) {
    errors.disease_type_other = "Campo obligatorio";
  }
  errors.social_security_affiliation = v_required(
    values.social_security_affiliation
  );
  errors.why_participate_in_tests = v_required(values.why_participate_in_tests);
  errors.intolerance_reaction_cosmetics = v_required(
    values.intolerance_reaction_cosmetics
  );
  if (values.intolerance_reaction_cosmetics === "2") {
    errors.intolerance_reaction_cosmetics_value = v_required(
      values.intolerance_reaction_cosmetics_value
    );
  }
  errors.prone_to_conjunctivitis = v_required(values.prone_to_conjunctivitis);
  errors.prone_to_herpes = v_required(values.prone_to_herpes);
  errors.prone_to_allergic_rhinitis = v_required(
    values.prone_to_allergic_rhinitis
  );
  errors.prone_to_asthma_crisis = v_required(values.prone_to_asthma_crisis);

  // Step 3
  errors.skin_type = v_required(values.skin_type);
  errors.skin_nature = v_required(values.skin_nature);
  errors.sensitive_facial_skin = v_required(values.sensitive_facial_skin);
  errors.facial_skin_atopic_tendency = v_required(
    values.facial_skin_atopic_tendency
  );
  errors.lips_nature = v_required(values.lips_nature);
  errors.sensitive_lips = v_required(values.sensitive_lips);
  errors.body_skin_nature = v_required(values.body_skin_nature);
  errors.sensitive_body_skin = v_required(values.sensitive_body_skin);
  errors.have_cellulite = v_required(values.have_cellulite);
  if (values.have_cellulite === "2") {
    errors.have_cellulite_value = v_required(values.have_cellulite_value);
  }

  errors.has_stretch_marks = v_required(values.has_stretch_marks);
  errors.has_pigmentation_spots_neckline = v_required(
    values.has_pigmentation_spots_neckline
  );
  errors.hand_skin_nature = v_required(values.hand_skin_nature);
  errors.has_sensitive_hands = v_required(values.has_sensitive_hands);
  errors.has_pigmentation_spots_on_hands = v_required(
    values.has_pigmentation_spots_on_hands
  );

  // Step 4
  errors.has_sensitive_eyes = v_required(values.has_sensitive_eyes);
  errors.wear_glasses = v_required(values.wear_glasses);
  errors.wear_contact_lenses = v_required(values.wear_contact_lenses);
  errors.had_eyes_problems = v_required(values.had_eyes_problems);
  if (values.had_eyes_problems === "2") {
    errors.had_eyes_problems_value = v_required(values.had_eyes_problems_value);
  }

  // Step 5
  errors.has_sensitive_scalp = v_required(values.has_sensitive_scalp);
  errors.scalp_nature = v_required(values.scalp_nature);
  errors.hair_nature = v_required(values.hair_nature);
  errors.hair_state = v_required(values.hair_state);
  errors.hair_type = v_required(values.hair_type);
  errors.hair_color = v_required(values.hair_color);
  errors.hair_length = v_required(values.hair_length);
  errors.dyed_hair = v_required(values.dyed_hair);
  errors.hair_loss = v_required(values.hair_loss);
  errors.hair_dandruff = v_required(values.hair_dandruff);
  //errors.profile.consumer_usual_products = v_required(values.profile.consumer_usual_products);
  errors.use_hair_removal_products = v_required(
    values.use_hair_removal_products
  );
  // if (values.use_hair_removal_products === '1') {
  errors.use_hair_removal_products_value = v_required(
    values.use_hair_removal_products_value
  );
  errors.hair_removal_methods = v_required(values.hair_removal_methods);
  errors.buy_products_from = v_required(values.buy_products_from);
  // }
  if (
    values.use_hair_removal_products === "2" &&
    (!values.hair_removal_zones || values.hair_removal_zones.length < 1)
  ) {
    errors.hair_removal_zones = "Campo obligatorio";
  }
  errors.use_bio_products = v_required(values.use_bio_products);
  errors.is_smoking = v_required(values.is_smoking);
  errors.has_tattoos = v_required(values.has_tattoos);
  if (values.has_tattoos && values.has_tattoos === "2") {
    errors.has_tattoos_value = v_required(values.has_tattoos_value);
  }
  errors.enrolled_in_other_center = v_required(values.enrolled_in_other_center);
  errors.had_recent_surgery = v_required(values.had_recent_surgery);
  if (values.had_recent_surgery === "2") {
    errors.had_recent_surgery_value = v_required(
      values.had_recent_surgery_value
    );
  }
  if (
    values.use_hair_removal_products === "2" &&
    values.hair_removal_methods &&
    values.hair_removal_methods.length < 1
  ) {
    errors.hair_removal_methods = "Campo obligatorio";
  }
  if (
    values.use_hair_removal_products === "2" &&
    values.buy_products_from &&
    values.buy_products_from.length < 1
  ) {
    errors.buy_products_from = "Campo obligatorio";
  }
  errors.policies = v_policy(2, values.policies);
  if (values. is_smoking && (!values.smoking_user_input || values.smoking_user_input.length === 0)) {
    errors.smoking_user_input = "Campo obligatorio";
  }
  // }

  return errors;
};

const styles = theme => ({
  root: {
    maxWidth: 400,
    flexGrow: 1
  },
  mobileStepper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%"
  },
  logIn: {
    textTransform: "initial",
    padding: 0,
    fontWeight: 300,
    color: "#4CE1B6",
    //lineHeight: '2.4em',
    //fontSize: '0.69rem',

    display: "inline-block"
  },
  mt: {
    marginTop: 20
  },
  buttonIndigo: theme.custom.button.indigo
});

class RegisterConsumerForm extends React.PureComponent {
  state = {
    activeStep: 0,
    has_children: false,
    accept_children_to_test: false
  };

  componentDidMount() {
    this.props.change("account_type", "2");
    if (this.state.activeStep > 0) {
      this.props.changeLayout(this.state.activeStep);
    }
  }

  checkEmailandNext = () => {
    if (
      this.textInput.value == undefined ||
      this.textPassword.value == undefined
    ) {
      this.props.dispatch(
        common_alertOpen("Please fill in the email and password fields")
      );
    } else {
      API.checkEmail(this.textInput.value)
        .then(status => {
          status.status === 409
            ? this.props.dispatch(
                common_alertOpen("Ya existe un usuario con este email")
              )
            : this.setState(state => ({
                activeStep: state.activeStep + 1
              }));
        })
        .catch(err => console.log(err));
    }
  };

  handleNext = () => {
    if (this.props.valid && this.state.activeStep < 5) {
      console.log("-------1");

      this.setState(state => ({
        activeStep: state.activeStep + 1
      }));
    } else if(!this.props.valid) {
      console.log("-------2");

      if (this.state.activeStep === 0) {
        console.log("-------3");
        this.props.touch("email");
        this.props.touch("password");
      }
      if (this.state.activeStep === 1) {
        this.props.touch("first_name");
        this.props.touch("last_name");
        this.props.touch("dni");
        this.props.touch("birthday");
        this.props.touch("address");
        this.props.touch("city");
        this.props.touch("postal_code");
        this.props.touch("mobile_phone_number");
        this.props.touch("gender");
        this.props.touch("weight");
        this.props.touch("height");
        this.props.touch("has_different_delivery_address");
        this.props.touch("preferred_delivery_time");
        this.props.touch("address_has_doorkeeper");
        this.props.touch("delivery_address");
      }
      if (this.state.activeStep === 2) {
        this.props.touch("work_status");
        this.props.touch("work_status_other");
        this.props.touch("how_you_know_about_cosmocare");
        this.props.touch("how_you_know_about_cosmocare_other");
        this.props.touch("using_social_networks");
        this.props.touch("social_networks");
        this.props.touch("social_networks_answer[6]");
        this.props.touch("social_security_affiliation");
        this.props.touch("why_participate_in_tests");
        this.props.touch("prone_to_conjunctivitis");
        this.props.touch("prone_to_herpes");
        this.props.touch("prone_to_allergic_rhinitis");
        this.props.touch("prone_to_asthma_crisis");
        this.props.touch("intolerance_reaction_cosmetics");
        this.props.touch("intolerance_reaction_cosmetics_value");
        this.props.touch("health_problems[9]");
        this.props.touch("health_problems[8]");
        this.props.touch("disease_type_other");
      }
      if (this.state.activeStep === 3) {
        this.props.touch("skin_type");
        this.props.touch("skin_nature");
        this.props.touch("sensitive_facial_skin");
        this.props.touch("facial_skin_atopic_tendency");
        this.props.touch("lips_nature");
        this.props.touch("sensitive_lips");
        this.props.touch("body_skin_nature");
        this.props.touch("sensitive_body_skin");
        this.props.touch("have_cellulite");
        this.props.touch("have_cellulite_value");
        this.props.touch("has_stretch_marks");
        this.props.touch("has_pigmentation_spots_neckline");
        this.props.touch("hand_skin_nature");
        this.props.touch("has_sensitive_hands");
        this.props.touch("has_pigmentation_spots_on_hands");
      }
      if (this.state.activeStep === 4) {
        this.props.touch("has_sensitive_eyes");
        this.props.touch("wear_glasses");
        this.props.touch("wear_contact_lenses");
        this.props.touch("had_eyes_problems");
        this.props.touch("had_eyes_problems_value");
      }
      if (this.state.activeStep === 5) {
        this.props.touch("has_sensitive_scalp");
        this.props.touch("scalp_nature");
        this.props.touch("hair_nature");
        this.props.touch("hair_state");
        this.props.touch("hair_type");
        this.props.touch("hair_color");
        this.props.touch("hair_length");
        this.props.touch("dyed_hair");
        this.props.touch("hair_loss");
        this.props.touch("hair_dandruff");
        //this.props.touch('profile[consumer_usual_products]');
        this.props.touch("use_hair_removal_products");
        this.props.touch("use_hair_removal_products_value");
        this.props.touch("hair_removal_methods");
        this.props.touch("buy_products_from");
        this.props.touch("use_bio_products");
        this.props.touch("is_smoking");
        this.props.touch("has_tattoos");
        // this.props.touch('profile[has_tattoos_value]');
        this.props.touch("enrolled_in_other_center");
        this.props.touch("had_recent_surgery");
        this.props.touch("had_recent_surgery_value");
        this.props.touch("policies");
      }

      this.props.dispatch(
        common_alertOpen(
          "Este formulario contiene errores. Por favor, corrígelos!"
        )
      );
    }
    let el = document.getElementById("root");
    el.scrollTop = 0;
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.activeStep !== prevState.activeStep) {
      this.props.changeLayout(this.state.activeStep);
    }

    if (this.props.countryValue !== prevProps.countryValue) {
      this.props.dispatch(geo_fetchRegions(this.props.countryValue));
    }

    if (this.props.regionValue !== prevProps.regionValue) {
      this.props.dispatch(
        geo_fetchCities(this.props.countryValue, this.props.regionValue)
      );
    }
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      classes,
      form_has_different_delivery_address_value,
      form_work_status_value,
      form_height_value,
      form_buy_products_from,
      form_consumer_usual_products,
      form_health_problems_value,
      form_social_networks,
      form_how_you_know_about_cosmocare_value,
      form_using_social_networks_value,
      form_intolerance_reaction_cosmetics_value,
      form_have_cellulite_value,
      form_had_eyes_problems_value,
      form_use_hair_removal_products_value,
      form_has_tattoos_value,
      form_had_recent_surgery_value,
      form_is_smoking,
      form_skin_characteristics
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
      >
        {this.state.activeStep > 0 && this.state.activeStep <= 5 && (
          <React.Fragment>
            <MobileStepper
              variant="progress"
              steps={5}
              position="static"
              activeStep={this.state.activeStep}
              style={{ width: "100%", marginTop: 20 }}
              classes={{
                progress: classes.progress
              }}
              LinearProgressProps={{
                variant: "determinate",
                value: Math.ceil((this.state.activeStep / 5) * 100),
                style: { width: "100%" }
              }}
            />
            <Typography variant="caption" align="right">
              <span style={{ color: "black" }}>{this.state.activeStep}</span> /
              5
            </Typography>
          </React.Fragment>
        )}
        {this.state.activeStep === 0 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <React.Fragment>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}>
                  <Email style={{ color: primaryGrey }} />
                </Grid>
                <Grid item xs={9}>
                  <div style={{ paddingLeft: 5 }}>
                    <Field
                      name="email"
                      component={renderTextField}
                      ref={input => {
                        this.textInput = input;
                      }}
                      label="Dirección de correo electrónico"
                    />
                  </div>
                </Grid>
                <Grid item xs={1}></Grid>
              </React.Fragment>

              <React.Fragment>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}>
                  <LockOutlined style={{ color: primaryGrey }} />
                </Grid>
                <Grid item xs={9}>
                  <div style={{ paddingLeft: 5 }}>
                    <Field
                      name="password"
                      component={renderTextField}
                      ref={input => {
                        this.textPassword = input;
                      }}
                      label="Crea tu contraseña"
                      type="password"
                    />
                  </div>
                </Grid>
                <Grid item xs={1}></Grid>
              </React.Fragment>

              <React.Fragment>
                <Grid item xs={6} align="center">
                  <Button
                    variant="outlined"
                    color="secondary"
                    disabled={this.state.activeStep === 0}
                    onClick={this.handleBack}
                  >
                    Atrás
                  </Button>
                </Grid>
                <Grid item xs={6} align="center">
                  <Button
                    variant="contained"
                    disabled={pristine || submitting}
                    className={this.props.classes.buttonIndigo}
                    onClick={this.checkEmailandNext}
                  >
                    Siguiente
                  </Button>
                </Grid>
              </React.Fragment>
              <React.Fragment>
                <Grid item xs={12} align="center">
                  <Typography paragraph style={{ marginTop: 25 }}>
                    Si tienes una cuenta{" "}
                    <Typography
                      component={Link}
                      to="/auth/login"
                      className={classes.logIn}
                    >
                      Inicia sesión
                    </Typography>
                  </Typography>
                </Grid>
              </React.Fragment>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 1 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                {renderFirstNameField("Nombre *")}
              </Grid>
              <Grid item xs={12}>
                {renderLastNameField("Primer apellido *")}
              </Grid>
              <Grid item xs={12}>
                {renderSecondLastNameField("Segundo apellido")}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" style={{ fontWeight: 400 }}>
                  Sexo
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenderField("", "gender")}
              </Grid>
              <Grid item xs={12}>
                {renderHeightField("Altura (m)", "height")}
              </Grid>
              <Grid item xs={12}>
                {renderWeightField("Peso (kg)", "weight")}
              </Grid>
              <Grid item xs={1}>
                <CalendarTodayOutlined style={{ color: primaryGrey }} />
              </Grid>
              <Grid item xs={11}>
                <div style={{ paddingLeft: 5 }}>{renderDateOfBirthField()}</div>
              </Grid>
              <Grid item xs={12}>
                {renderAddressField()}
              </Grid>
              <Grid item xs={12}>
                {renderCityField()}
              </Grid>
              <Grid item xs={12}>
                {renderPostalCodeField()}
              </Grid>
              <Grid item xs={12}>
                {renderMobilePhoneField()}
              </Grid>
              <Grid item xs={12}>
                {renderAlternativePhoneNumberField()}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Dirección de envío de las muestras{" "}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "has_different_delivery_address",
                  fullWidth: true,
                  options: [
                    { id: 1, value: "Misma que la del domicilio" },
                    { id: 2, value: "Otra" }
                  ]
                })}
                {form_has_different_delivery_address_value == 2 &&
                  renderAddressField("Otra dirección", "delivery_address")}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Disponibilidad horaria para la recepción de los productos
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenericCheckboxGroup({
                  name: "preferred_delivery_time",
                  fullWidth: true,
                  options: [
                    { id: 1, value: "Mañana", label: "Mañana" },
                    { id: 2, value: "Tarde", label: "Tarde" }
                  ]
                })}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Hay un portero en tu edificio (o alguien que pueda recibir
                  paquetes)?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "address_has_doorkeeper",
                  options: this.props.common.yesno || []
                })}
              </Grid>

              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
                <Button
                  variant="contained"
                  className={this.props.classes.buttonIndigo}
                  onClick={this.handleNext}
                >
                  Siguiente
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 2 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="subheading" style={{ fontWeight: 500 }}>
                  Información general
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Actividad Laboral
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "work_status",
                  options: this.props.common.work_status || [],
                  fullWidth: true
                })}
                {form_work_status_value == 9 &&
                  renderGenericTextField("Otros", "work_status_other")}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Cómo has conocido CosmoCare?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenericCheckboxGroup({
                  name: "how_you_know_about_cosmocare",
                  options: this.props.common.how_you_know_about_cosmocare || [],
                  fullWidth: true
                })}
                {form_how_you_know_about_cosmocare_value &&
                  form_how_you_know_about_cosmocare_value.map(
                    value =>
                      value === 5 &&
                      renderGenericTextField(
                        "Otro",
                        "how_you_know_about_cosmocare_other"
                      )
                  )}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Utilizas alguna de las siguientes redes sociales?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenericCheckboxGroup({
                  options: this.props.common.social_networks,
                  name: "social_networks"
                })}
                {form_social_networks &&
                  form_social_networks.map(
                    value =>
                      value === 6 &&
                      renderGenericTextField("¿Cuál?", "social_networks_other")
                  )}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Estás afiliado/a a la Seguridad Social?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "social_security_affiliation",
                  options: this.props.common.yesno || []
                })}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Por qué te gustaría participar en estos tests?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenericTextField(
                  "Tu respuesta",
                  "why_participate_in_tests"
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Presenta algún problema de salud de los que aparecen en la
                  siguiente lista?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenericCheckboxGroup({
                  options: this.props.common.health_problems,
                  name: "health_problems"
                })}
                {form_health_problems_value &&
                  form_health_problems_value.map(
                    value =>
                      value === 9 &&
                      renderGenericTextField("Otro", "disease_type_other")
                  )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Tomas de manera habitual (diaria, semanal…) alguno de los
                  medicamentos de la siguiente lista?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenericCheckboxGroup({
                  options: this.props.common.you_take_medicine,
                  name: "you_take_medicine"
                })}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Presenta alguna de las afecciones dermatológicas de las que
                  aparecen en la siguiente lista?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderGenericCheckboxGroup({
                  options: this.props.common.derma_affections,
                  name: "derma_affections",
                  enableAnswer: true
                })}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Eres propenso a tener...
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Conjuntivitis
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "prone_to_conjunctivitis",
                  options: this.props.common.yesno || []
                })}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Herpes
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "prone_to_herpes",
                  options: this.props.common.yesno || []
                })}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Rinitis alérgica
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "prone_to_allergic_rhinitis",
                  options: this.props.common.yesno || []
                })}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  Crisis de asma
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "prone_to_asthma_crisis",
                  options: this.props.common.yesno || []
                })}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Has tenido alguna vez algún tipo de reacción de intolerancia
                  a productos cosméticos?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "intolerance_reaction_cosmetics",
                  options: this.props.common.yesno || []
                })}
                {form_intolerance_reaction_cosmetics_value == 2 &&
                  renderGenericTextField(
                    "Ante qué producto(s):",
                    "intolerance_reaction_cosmetics_value"
                  )}
              </Grid>

              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
                <Button
                  variant="contained"
                  className={this.props.classes.buttonIndigo}
                  onClick={this.handleNext}
                >
                  Siguiente
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 3 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="subheading" style={{ fontWeight: 500 }}>
                  Características de tu piel
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" style={{ marginTop: 15 }}>
                  Especifica cuál es tu tipo de piel:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <img src={fototipo} style={{ maxWidth: "100%" }} />
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "skin_type",
                  options: this.props.common.skin_types || [],
                  fullWidth: true,
                  alignTop: true
                })}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" style={{ marginTop: 15 }}>
                  Especifica la naturaleza de la piel de tu rostro:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "skin_nature",
                  options: this.props.common.skin_nature || [],
                  fullWidth: true
                })}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" className={classes.mt}>
                  ¿Tienes la piel del rostro sensible (piel con reacciones de
                  quemazón, sensación de tirantez, calentura, rojez o picor por
                  cambios de temperatura, estrés, cambios hormonales, frío,
                  viento, sol...)?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderOptionsField({
                  name: "sensitive_facial_skin",
                  options: this.props.common.yesno || []
                })}
              </Grid>

              <GridField
                title="¿La piel del rostro tiene tendencia atópica (piel muy seca que reacciona ante la 
                mínima agresión externa, como el viento, el frío, el estrés...)?"
              >
                {renderOptionsField({
                  name: "facial_skin_atopic_tendency",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Tu rostro presenta alguna de las características siguientes?">
                {renderGenericCheckboxGroup({
                  name: "skin_characteristics",
                  options: this.props.common.skin_characteristics || []
                })}
                {console.log('form_skin_characteristics', form_skin_characteristics)}
                {Array.isArray(form_skin_characteristics) && form_skin_characteristics.find(c => c === 15) > -1 && renderGenericTextField(
                    "Otros",
                    "skin_characteristics_other"
                )}
              </GridField>

              <GridField title="Especifica la naturaleza de tus labios:">
                {renderOptionsField({
                  name: "lips_nature",
                  options: this.props.common.lips_nature || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField
                title="¿Tienes los labios sensibles (posibles reacciones ante cambios de 
                temperatura, estrés, frío, viento, sol...)?"
              >
                {renderOptionsField({
                  name: "sensitive_lips",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="Especifica la naturaleza de la piel de tu cuerpo:">
                {renderOptionsField({
                  name: "body_skin_nature",
                  options: this.props.common.body_skin_nature || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField
                title="¿Tienes la piel del cuerpo sensible? (piel con reacciones de quemazón, sensación de 
                tirantez, calentura, rojez o picor por cambios de temperatura, estrés, cambios 
                hormonales, frío, viento, sol...)?"
              >
                {renderOptionsField({
                  name: "sensitive_body_skin",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField
                title="¿Tienes celulitis?"
                needsUserInput={form_have_cellulite_value == 2}
                userInputComponent={renderOptionsField({
                  name: "have_cellulite_value",
                  options: this.props.common.cellulite_type || [],
                  fullWidth: true
                })}
              >
                {renderOptionsField({
                  name: "have_cellulite",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Tienes estrías en el cuerpo?">
                {renderOptionsField({
                  name: "has_stretch_marks",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Tienes manchas de pigmentación en el escote?">
                {renderOptionsField({
                  name: "has_pigmentation_spots_neckline",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="Especifica la naturaleza de la piel de tus manos:">
                {renderOptionsField({
                  name: "hand_skin_nature",
                  options: this.props.common.hand_skin_nature || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField
                title="¿Tienes las manos sensibles (piel con reacciones de quemazón, 
              sensación de tirantez, calentura, rojez o picor por cambios de temperatura, 
              estrés, cambios hormonales, frío, viento, sol...)?"
              >
                {renderOptionsField({
                  name: "has_sensitive_hands",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Tienes manchas de pigmentación en las manos?">
                {renderOptionsField({
                  name: "has_pigmentation_spots_on_hands",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
                <Button
                  variant="contained"
                  className={this.props.classes.buttonIndigo}
                  onClick={this.handleNext}
                >
                  Siguiente
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 4 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="subheading" style={{ fontWeight: 500 }}>
                  Características oculares
                </Typography>
              </Grid>

              <GridField title="¿Tienes los ojos sensibles (reaccionan al viento, frío, sol...)?">
                {renderOptionsField({
                  name: "has_sensitive_eyes",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Llevas gafas?">
                {renderOptionsField({
                  name: "wear_glasses",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Llevas lentillas?">
                {renderOptionsField({
                  name: "wear_contact_lenses",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField
                title="¿Has tenido alguna vez problemas oculares?"
                needsUserInput={form_had_eyes_problems_value == 2}
                userInputComponent={renderGenericTextField(
                  "Especifica qué problema(s):",
                  "had_eyes_problems_value"
                )}
              >
                {renderOptionsField({
                  name: "had_eyes_problems",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
                <Button
                  variant="contained"
                  className={this.props.classes.buttonIndigo}
                  onClick={this.handleNext}
                >
                  Siguiente
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 5 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="subheading" style={{ fontWeight: 500 }}>
                  Características de tu cabello
                </Typography>
              </Grid>

              <GridField
                title="¿Tienes el cuero cabelludo sensible? (piel con reacciones de 
              quemazón, sensación de tirantez, calentura, rojez o picor por cambios de 
              temperatura, estrés, cambios hormonales, frío, viento, sol...)"
              >
                {renderOptionsField({
                  name: "has_sensitive_scalp",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="Especifica la naturaleza de tu cuero cabelludo">
                {renderOptionsField({
                  name: "scalp_nature",
                  options: this.props.common.hair_and_scalp_nature || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField title="Especifica la naturaleza de tu cabello">
                {renderOptionsField({
                  name: "hair_nature",
                  options: this.props.common.hair_and_scalp_nature || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField title="Especifica el estado de tu cabello">
                {renderOptionsField({
                  name: "hair_state",
                  options: this.props.common.hair_state || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField title="Especifica tu tipo de cabello">
                {renderOptionsField({
                  name: "hair_type",
                  options: this.props.common.hair_type || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField title="Especifica cuál es el color de tu cabello">
                {renderOptionsField({
                  name: "hair_color",
                  options: this.props.common.hair_color || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField title="¿Qué longitud tiene tu cabello?">
                {renderOptionsField({
                  name: "hair_length",
                  options: this.props.common.hair_length || [],
                  fullWidth: true
                })}
              </GridField>

              <GridField title="¿Tienes el pelo teñido o con mechas, o sueles teñírtelo?">
                {renderOptionsField({
                  name: "dyed_hair",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Sufres caída de cabello o alopecia?">
                {renderOptionsField({
                  name: "hair_loss",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Tienes tendencia a tener caspa?">
                {renderOptionsField({
                  name: "hair_dandruff",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="Selecciona los productos de la siguiente lista que uses habitualmente">
                {renderGenericCheckboxGroup({
                  name: "consumer_usual_products",
                  options: this.props.common.consumer_usual_products || []
                })}
                {form_consumer_usual_products &&
                  form_consumer_usual_products.map(
                    value =>
                      value === 43 &&
                      renderGenericTextField(
                        "Otro",
                        "consumer_usual_products_other"
                      )
                  )}
              </GridField>

              <GridField title="¿Utilizas productos para depilarte?">
                {renderOptionsField({
                  name: "use_hair_removal_products",
                  options: this.props.common.yesno || []
                })}
              </GridField>
              {form_use_hair_removal_products_value == 2 && (
                <React.Fragment>
                  <GridField title="¿Dónde? (zona)">
                    {renderGenericCheckboxGroup({
                      name: "hair_removal_zones",
                      options: this.props.common.hair_zones || []
                    })}
                  </GridField>
                  <GridField title="¿Qué método utilizas? (Escoge tantos como sea necesario) ">
                    {renderGenericCheckboxGroup({
                      name: "hair_removal_methods",
                      options: this.props.common.hair_removal_methods || []
                    })}
                  </GridField>
                </React.Fragment>
              )}
              <GridField title="¿Dónde compras los productos cosméticos?">
                {renderGenericCheckboxGroup({
                  name: "buy_products_from",
                  options: this.props.common.buy_products_from || []
                })}
                {form_buy_products_from &&
                  form_buy_products_from.map(
                    value =>
                      value === 7 &&
                      renderGenericTextField("Otro", "buy_products_from_other")
                  )}
              </GridField>
              <GridField title="¿Usas productos cosméticos bio, ecológicos u orgánicos?">
                {renderOptionsField({
                  name: "use_bio_products",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField
                title="¿Eres fumador/a?"
                needsUserInput={form_is_smoking == 2}
                userInputComponent={renderGenericTextField(
                  "¿Cuántos cigarros fumadora al día?",
                  "smoking_user_input"
                )}
              >
                {renderOptionsField({
                  name: "is_smoking",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField
                title="¿Tienes tatuajes?"
                needsUserInput={form_has_tattoos_value == 2}
                userInputComponent={renderGenericTextField(
                  "Qué zona(s):",
                  "has_tattoos_value"
                )}
              >
                {renderOptionsField({
                  name: "has_tattoos",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="¿Estás apuntado/a a otro centro de pruebas cosméticas?">
                {renderOptionsField({
                  name: "enrolled_in_other_center",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField
                title="¿Te han operado durante los últimos 12 meses?"
                needsUserInput={form_had_recent_surgery_value == 2}
                userInputComponent={renderGenericTextField(
                  "¿Motivo?",
                  "had_recent_surgery_value"
                )}
              >
                {renderOptionsField({
                  name: "had_recent_surgery",
                  options: this.props.common.yesno || []
                })}
              </GridField>

              <GridField title="">
                {renderGenericCheckboxGroup({
                  name: "policies",
                  options: [
                    {
                      id: 1,
                      value: (
                        <Typography variant="caption">
                          Sí, he leido y doy el &nbsp;
                          <Typography
                            component={Link}
                            to="/consentimiento-consumidores"
                            variant="caption"
                            target="_blank"
                            style={{ display: "inline-block" }}
                          >
                            <strong>consentimiento</strong>
                          </Typography>{" "}
                          &nbsp; para CosmoCare
                        </Typography>
                      )
                    },
                    {
                      id: 2,
                      value: (
                        <Typography variant="caption">
                          Acepto las &nbsp;
                          <Typography
                            component={Link}
                            to="/aviso-legal"
                            variant="caption"
                            target="_blank"
                            style={{ display: "inline-block" }}
                          >
                            <strong>condiciones generales</strong>
                          </Typography>
                          &nbsp; y apruebo el uso de datos personales
                        </Typography>
                      )
                    }
                  ]
                })}
              </GridField>

              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 45 }}>
                <Button
                  variant="contained"
                  type="submit"
                  className={this.props.classes.buttonIndigo}
                  disabled={pristine || submitting}
                  onClick={this.handleNext}
                >
                  REGÍSTRATE
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}

        {/*this.state.activeStep === 6 && 
        <React.Fragment>
          <Grid container spacing={8} alignItems="flex-end">

            <Grid item xs={6} align="center">
              <Button variant="outlined" disabled={this.state.activeStep === 0} onClick={this.handleBack}>Atrás</Button>
            </Grid>
            <Grid item xs={6} align="center" style={{paddingTop: 45}}>
              <Button 
                variant="contained" 
                type="submit" 
                className={this.props.classes.buttonIndigo} 
                disabled={pristine || submitting}
              >
                Registrate
              </Button>
            </Grid>
          </Grid>
        </React.Fragment>
        */}
      </form>
    );
  }
}

RegisterConsumerForm = reduxForm({
  form: "registerConsumerAccount",
  validate,
  rerenderOnEveryChange: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})(RegisterConsumerForm);

export default withStyles(styles, { withTheme: true })(RegisterConsumerForm);



// WEBPACK FOOTER //
// ./src/modules/register/forms/RegisterConsumerForm.js